type JobBudgetType =
  | '%other'
  | 'FixedPriceJobBudget'
  | 'HourlyRateJobBudget'
  | 'MonthlyRateJobBudget'
  | 'WeeklyRateJobBudget';

export const getBudgetVariantTimeframe = (typename: JobBudgetType) => {
  switch (typename) {
    case 'HourlyRateJobBudget':
      return '/hr';
    case 'MonthlyRateJobBudget':
      return '/mo';
    case 'WeeklyRateJobBudget':
      return '/wk';
    default:
      return null;
  }
};
